define([
	"dojo/_base/declare",
	"csi/table/Copy",
	"SiteAdmin/DataSheetForm"
], function(declare,Copy,DataSheetForm) {

	return declare(Copy, {
		/**
		 * Add special controller for form
		 */
		onCreatePopupDefView: function(defView) {
			defView.classController = DataSheetForm;
		}
	});
});
